import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
const AdminPasswordReset = ({show , adminName , form,  handleChange , onSave , onHide}) => {
  return (
      <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{`Change ${adminName}'s Password`}</Modal.Title>
      </Modal.Header>
      <Form>
        <Modal.Body>
          <Form.Group className="mb-3" controlId="formFirstName" onSubmit={onSave}>
            <Form.Label>Password</Form.Label>
            <Form.Control
              type="text"
              name="password"
              value={form.password}
              onChange={handleChange}
              placeholder="Enter Password"
              required
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="formLastName">
            <Form.Label>Confirm Password</Form.Label>
            <Form.Control
              type="password"
              name="confirmPassword"
              value={form.confirmPassword}
              onChange={handleChange}
              placeholder="Confirm Password"
              required
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Cancel
          </Button>
          <Button variant="primary" type="submit" onClick={(e) => onSave(e , adminName)} disabled={form.password !== form.confirmPassword || !form.password || !form.confirmPassword}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  )
}

export default AdminPasswordReset